<template>
  <div
  >
    <no-ssr>
      <div
        @mouseover="isShow = true"
        @mouseleave="isShow = false"
        @click="inviteFriends"
        class="WaterWaveBall"
        v-show="isLogin && isShowBall"
      >
        <div class="wave">
          <canvas id="c"></canvas>
        </div>
        <div class="b">
          <span class="count">{{ remainCount }}</span>
          <div class="count-txt">剩余下载总数</div>
        </div>

        <div class="wave-comboBox"  v-show="isShow">
          <div class="header">
            <i class="icon-gif"></i>
            免费下载福利
          </div>
          <div class="content">
            <div class="count-box">
              <span class="count-box-text">今日剩余</span>
              <span class="count-box-num">{{ free_remain }}</span>
              <span class="line"></span>
              <span class="count-box-text">总剩余</span>
              <span class="count-box-num">{{ remainCount }}</span>

            </div>
<!--            <div @click="inviteFriends" class="count-btn">
              提高下载次数
            </div>-->
            <span
              @click="inviteFriends"
              class="tips">10次下载仅注册10天内有效</span>

          </div>
        </div>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {fnInviteFriend, fnLogin, fnUser} from "@/fn";

export default {
  name: "WaterWaveBall",
  computed: {
    ...mapState('user',
      [
        'userInfo',
        'name', 'isLogin', 'uid', 'avatar', 'uniq_id', 'vipIsPerson', 'vipIsPersonData', 'vipIsBusiness', 'vipIsBusinessData', 'downloadCount']),

    remainCount() {
      let {free_down_cnt, down_cnt} = this.downloadCount
      return free_down_cnt - down_cnt;
    },
    free_remain() {
      let {
        day_free_limit, today_free_down, free_down_cnt, down_cnt
      } = this.$store.state.user.downloadCount;
      /* 判断总免费次数是否有用完 */
      let free_remain = free_down_cnt - down_cnt > 0 ? (day_free_limit - today_free_down) : 0;
      return free_remain;
    },

  },
  data() {
    return {
      isNoVip: false,
      registerDay: 0,
      isShow: false,

      isShowBall: false
    }
  },

  watch: {
    isLogin(n, o) {
      if (n == true) {
        this.init();
      }
    }
  },

  mounted() {

    this.init();
  },
  methods: {

    init() {
      if (!fnLogin.checkLogin()) {
        return
      }
      setTimeout(() => {
       try {
         let {free_down_cnt, down_cnt} = this.downloadCount
         let rate = (free_down_cnt - down_cnt) / free_down_cnt * 100;
         rate = rate <= 10 ? 20 : rate;
         rate = rate >= 80 ? 82 : rate;
         this.drawWater('c', rate, 160, '#41EBD3', '#41EBD3', 'rgba(65, 235, 211, 0.3)');

       }catch (e){
         console.log(e)
       }

        this.isNoVip = fnUser.checkUserIsNoVip();
        this.vipAboutToExpireList = fnUser.checkUserIsAboutToExpire();
        this.registerDay = fnUser.checkUserRegisterDay();

        console.log((this.isLogin && this.registerDay <= 3 && this.isNoVip))
        console.log((this.isLogin && this.registerDay > 3 && this.userInfo.is_inviter != -1 && this.isNoVip))

        if (
          (this.isLogin && this.registerDay <= 3 && this.isNoVip) ||
          (this.isLogin && this.registerDay > 3 && this.userInfo.is_inviter != -1 && this.isNoVip)
        ) {
          console.log(  11111)
          this.isShowBall = true

        } else {
          this.isShowBall = false
        }



      }, 500)
    },

    inviteFriends() {
      fnInviteFriend.inviteFriendEntry(10);
    },


    drawWater(id, rate, width, borderColor, darkColor, lightColor) {
      var canvas = document.getElementById(id);
      var ctx = canvas.getContext('2d');
      // var range = document.getElementById('r');

      //range控件信息
      var rangeValue = rate;
      var nowRange = 40;   //用于做一个临时的range

      //画布属性
      var mW = canvas.width = width;
      var mH = canvas.height = width;
      var lineWidth = 1;

      //圆属性
      var r = mH / 2; //圆心
      var cR = r - 32 * lineWidth; //圆半径

      //Sin 曲线属性
      var sX = 0;
      var axisLength = mW; //轴长
      var waveWidth = 0.018;   //波浪宽度,数越小越宽
      var waveHeight = 16; //波浪高度,数越大越高
      var speed = 0.04; //波浪速度，数越大速度越快
      var xOffset = 0; //波浪x偏移量

      ctx.lineWidth = lineWidth;

      //画圈函数
      var IsdrawCircled = false;
      var drawCircle = function () {
        ctx.beginPath();
        ctx.strokeStyle = borderColor;
        ctx.arc(r, r, cR + 1, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(r, r, cR, 0, 2 * Math.PI);
        ctx.clip();

        IsdrawCircled = true;
      }

      //画sin 曲线函数
      var drawSin = function (xOffset, color, waveHeight) {
        ctx.save();

        var points = [];  //用于存放绘制Sin曲线的点

        ctx.beginPath();
        //在整个轴长上取点
        for (var x = sX; x < sX + axisLength; x += 20 / axisLength) {
          //此处坐标(x,y)的取点，依靠公式 “振幅高*sin(x*振幅宽 + 振幅偏移量)”
          var y = Math.sin((-sX - x) * waveWidth + xOffset) * 0.8 + 0.1;

          var dY = mH * (1 - nowRange / 100);

          points.push([x, dY + y * waveHeight]);
          ctx.lineTo(x, dY + y * waveHeight);
        }

        //封闭路径
        ctx.lineTo(axisLength, mH);
        ctx.lineTo(sX, mH);
        ctx.lineTo(points[0][0], points[0][1]);
        ctx.fillStyle = color;
        ctx.fill();

        ctx.restore();
      };

      var render = function () {
        ctx.clearRect(0, 0, mW, mH);

        rangeValue = rate;

        if (IsdrawCircled == false) {
          drawCircle();
        }

        if (nowRange <= rangeValue) {
          var tmp = 1;
          nowRange += tmp;
        }

        if (nowRange > rangeValue) {
          var tmp = 1;
          nowRange -= tmp;
        }

        drawSin(xOffset + Math.PI * 0.7, lightColor, 18);
        drawSin(xOffset, darkColor, 18);
        // drawText();

        xOffset += speed;
        requestAnimationFrame(render);
      }
      //写百分比文本函数
      var drawText = function () {
        ctx.save();

        var size = 0.4 * cR;
        ctx.font = size + 'px Microsoft Yahei';
        ctx.textAlign = 'center';
        ctx.fillStyle = "rgba(06, 85, 128, 0.5)";
        ctx.fillText(~~nowRange + '%', r, r + size / 2);

        ctx.restore();
      };

      render();
    },
  },

}
</script>

<style lang="scss" scoped>
@keyframes fadeinT {
  0% {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%, 0);
  }
}


.WaterWaveBall {
  position: absolute;
  z-index: 10;
  top: 68px;
  left: 478px;
  border-radius: 50%;
  cursor: pointer;
  animation: fadeinT 0.5s 1;

  transition: all 0.5s ease-in-out;
  //background-color: #fff;

  .b {
    //border: 1px solid #41EBD3;
    @include Position(1, 5, 0, 0);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 21;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    //justify-content: center;
    text-align: center;
    padding-top: 50px;

    .count {
      font-size: 28px;
      color: #1E3447;
      line-height: 37px;
    }

    .count-txt {
      font-size: 12px;
      color: #1E3447;
      line-height: 16px;
    }
  }

  .wave-comboBox {
    width: 164px;
    height: 95px;
    background: #2A3F52;
    border-radius: 8px;
    @include Position(1, 5, 50%, 124px);
    transform: translateX(-50%);
    overflow: hidden;
    animation: fadeinT 0.5s 1;

    .header {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #1E3447;
      font-size: 13px;
      color: #DFE2E5;
      line-height: 30px;

      .icon-gif {
        @include BgImage(12px, 12px, 'tupian/icon_gif.png');
        margin-right: 6px;
      }

    }

    .content {
      display: flex;
      align-items: center;
      flex-direction: column;

      .count-box {
        color: #FFFFFF;
        line-height: 16px;
        font-size: 0;
        margin: 9px 0 8px;
        height: 16px;

        .count-box-text {
          font-size: 12px;
          color: #FFFFFF;
          line-height: 16px;
        }

        .count-box-num {
          font-size: 13px;
          font-weight: bold;
          color: #41EBD3;
          line-height: 17px;
          margin-left: 4px;
        }

        .line {
          display: inline-block;
          width: 1px;
          height: 10px;
          background: #DFE2E5;
          border-radius: 1px;
          color: rgba(223, 226, 229, 0.5);
          margin: 0 8px;
        }
      }

      .count-btn {
        font-size: 12px;
        color: #DEEFFF;
        padding: 0 9px;
        background: #3F5E7B;
        border-radius: 12px;
        line-height: 22px;
      }

    }

    .tips{
      font-size: 12px;
      color: #DFE2E5;
      line-height: 30px;
    }

  }
}


@keyframes rotate {
  50% {
    transform: translate(-50%, -73%) rotate(180deg);
  }
  100% {
    transform: translate(-50%, -70%) rotate(360deg);
  }
}
</style>
